import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ContactUsService {
  showContactUsDialog = false;
  showContactUsIconInApp = true;
  showContactUsIconInChatInput = false;
}
